/*jslint indent: 2*/
/*global require: true, module: true*/
module.exports = {
  add: require('./add'),
  'best-of': require('./best-of'),
  divide: require('./divide'),
  multiply: require('./multiply'),
  subtract: require('./subtract'),
  sum: require('./sum'),
  'worst-of': require('./worst-of')
};

